import { ChangeDetectionStrategy, Component, computed, input, type InputSignal, type Signal } from '@angular/core';

import type { WishlistActivityFeedItemView } from '../../types/wishlist-activity-feed-item-view.interface';

@Component({
  selector: 'wishlist-activity-feed',
  imports: [],
  templateUrl: './wishlist-activity-feed.component.html',
  styleUrl: './wishlist-activity-feed.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WishlistActivityFeedComponent {
  public readonly activities: InputSignal<readonly WishlistActivityFeedItemView[]> =
    input<readonly WishlistActivityFeedItemView[]>([]);
  public readonly title: InputSignal<string> = input<string>('Ostatnia aktywność');
  public readonly emptyText: InputSignal<string> = input<string>('Aktywność pojawi się po pierwszych zmianach.');

  protected readonly hasActivities: Signal<boolean> = computed((): boolean => this.activities().length > 0);
}
